<!--列表查看视图-->
<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          class="section"
          style="min-width: 160px;width:100%;height:100%;"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 10px">
            <div class="filters">
              <!-- todo -->
            </div>
            <div class="triggers">
              <cargo-button-group-slider>
                <finance-btn-group source-view="detail" :job="job" :hp="financeDetailHp" style="flex-wrap:wrap;" :active-tab-name="activeTabName" />
              </cargo-button-group-slider>
              <div style="white-space: nowrap;">
                <label class="red" style="font-weight: bold;font-size: 15px;height: 25px;">{{ jobState }}</label>
                <!-- 「正操作」「预提交」「已提交」「已审核」业务状态存在费用时 进行退关操作后，需要显示为「XXX（有费用退关）」-->
                <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && !jobChangeState" class="red" style="font-weight: bold;font-size: 15px;height: 25px;">({{ $t('Message.HasChargeToShutOut') }})</font>
                <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && jobChangeState" class="red" style="font-weight: bold;font-size: 15px;height: 25px;">({{ $t('Message.HasChargeToShutOut') }}/{{ jobChangeState }})</font>
                <font v-if="!((job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut) && jobChangeState" class="red" style="font-weight: bold;font-size: 15px;height: 25px;">({{ jobChangeState }})</font>
                <!--todo 天眼查-->
                <label>{{ '' }}</label>
                <label class="blue" style="height: 25px;">{{ job.jobNo }}</label>
                <label class="blue" style="height: 25px;">{{ $store.getters.language === 'zh' ? customerChineseName : customerEnglishName }}</label>
                <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
                <!--<span style="font-weight: bold;color:red">{{ jobState }}</span>||
                <span style="font-weight: bold;color:red">{{ jobChangeState }}</span>||
                <span style="font-weight: bold;color:red">{{ job.jobNo }}</span>||
                <span style="font-weight: bold;color:red">{{ customerChineseName }}</span>-->
                <div v-if="pushExternalInterfaceStatus" style="position: fixed;z-index: 99;display: flex;">
                  <div style="color: #E6A23C;">{{ pushExternalInterfaceStatus }}</div>
                  <el-tooltip :content="$t('Clearing.NewGeneration')" placement="top-start">
                    <svg-icon icon-class="question" style="font-size: 14px;margin-left: 5px;margin-top: -2px;" />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs v-model="activeTabName" type="card" style="width: 100%" @tab-click="handleTabClick">
              <el-tab-pane :key="10" :lazy="true" :label="$t('CargoMsg.Cargo_Basic')" name="basic">
                <basic ref="basic" :lob="lob" :master-flag="masterFlag" :se-context="seContext" :job="job" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='SE'" :key="20" :lazy="true" name="tabVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-vessel-eq-UICustom v-if="$store.state.uiCustom.enable" ref="tabVesselEq" :context="seContext" :action="action" />
                <tab-vessel-eq v-else ref="tabVesselEq" :context="seContext" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='AE'" :key="40" :lazy="true" name="tabAirVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-air-vessel-eq-UICustom v-if="$store.state.uiCustom.enable" ref="tabAirVesselEq" :context="seContext" :action="action" />
                <tab-air-vessel-eq v-else ref="tabAirVesselEq" :context="seContext" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='IE' && job.containerLoadType === 'TT'" :key="30" :lazy="true" name="tabGatheringTrailer" :label="$t('SeaExport.GatheringTrailer')">
                <tab-gathering-trailer ref="tabGatheringTrailer" :context="seContext" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='IE' && job.containerLoadType === 'CL'" :key="31" :lazy="true" name="tabLessThanCarload" :label="$t('SeaExport.WholeVehicleLessThanCarload')">
                <tab-less-than-carload ref="tabLessThanCarload" :context="seContext" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='IE' && job.containerLoadType === 'IC'" :key="32" :lazy="true" name="tabOrderCar" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-order-car ref="tabOrderCar" :context="seContext" :action="action" />
              </el-tab-pane>
              <template>
                <template v-if="lob==='SE' || lob==='AE'">
                  <el-tab-pane v-if="!chargePageSet.hideTabCharge" :key="21" :lazy="true" name="tabCharges" :label="$t('CargoMsg.Cargo_Cost')">
                    <tab-charges ref="tabCharges" :context="seContext" :action="action" :adjust="adjust" :location="location" is-from-finance view-source="FinanceManage" :enable-ui-custom="true" />
                  </el-tab-pane>
                  <el-tab-pane v-if="chargePageSet.arAloneShow && privilege.charge.chargeReceivable" key="chargeArTab" :lazy="true" name="tabChargesAr" :label="$t('queryJob.FeeReceivable')">
                    <tab-charges ref="tabChargesAr" :context="seContext" :action="action" :adjust="adjust" :location="location" is-from-finance view-source="FinanceManage" tab-name="tabChargesAr" type="ar" :enable-ui-custom="true" />
                  </el-tab-pane>
                  <el-tab-pane v-if="chargePageSet.apAloneShow && privilege.charge.chargePayable" key="chargeApTab" :lazy="true" name="tabChargesAp" :label="$t('queryJob.CostsPayable')">
                    <tab-charges ref="tabChargesAp" :context="seContext" :action="action" :adjust="adjust" :location="location" is-from-finance view-source="FinanceManage" tab-name="tabChargesAp" type="ap" :enable-ui-custom="true" />
                  </el-tab-pane>
                </template>
                <el-tab-pane v-else :key="21" :lazy="true" name="tabCharges" :label="$t('CargoMsg.Cargo_Cost')">
                  <tab-charges ref="tabCharges" :context="seContext" :action="action" :adjust="adjust" :location="location" is-from-finance view-source="FinanceManage" />
                </el-tab-pane>
              </template>
              <el-tab-pane :key="22" :lazy="true" name="tabInternalBill" :label="$t('CargoMsg.Cargo_DomesticBill')">
                <tab-internal-bill ref="tabInternalBill" :context="seContext" :action="action" :location="location" :enable-ui-custom="$store.state.uiCustom.enable" :page-type="UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING" />
              </el-tab-pane>
              <el-tab-pane :key="23" :lazy="true" name="tabOverseaBill" :label="$t('CargoMsg.Cargo_InternationalBill')">
                <tab-oversea-bill
                  ref="tabOverseaBill"
                  :context="seContext"
                  :action="action"
                  :location="location"
                  view-source="financeDetail"
                  :enable-ui-custom="$store.state.uiCustom.enable"
                  :page-type="UICustomConstants.SEA_BOOKING_OVERSEA_BILL"
                />
              </el-tab-pane>
              <el-tab-pane :key="24" :lazy="true" name="tabAdvanceCharge" :label="$t('CargoMsg.Cargo_AdvanceChargeInfo')">
                <tab-advance-charge ref="tabAdvanceCharge" :context="seContext" :action="action" :adjust="adjust" :location="location" />
              </el-tab-pane>
              <el-tab-pane v-if="showTabSopState" :key="29" :lazy="true" name="tabSopState" :label="$t('CargoMsg.Cargo_BusinessStatus')">
                <tab-sop-state ref="tabSopState" :context="seContext" :action="action" is-from-finance />
              </el-tab-pane>
              <el-tab-pane :key="28" :lazy="true" name="tabFileHistory" :label="$t('CargoMsg.Cargo_FileHistory')">
                <tab-file-history ref="tabFileHistory" :context="seContext" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--批量更新汇率-->
    <update-exchange-rate-dialog
      :visible.sync="updateExchangeRateDialog.visible"
      :job-key-list="updateExchangeRateDialog.jobKeyList"
      :location="location"
    />
  </div>
</template>

<script>
// utils
import { getLoading4Cxt } from '@/utils/utilBaseElement'
// api
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import {} from '@/api/clearing/financeManage'
import FinanceDetailHp from './financeDetailHp'
// import { SeContext, SeParentContext } from './financeDetailHp'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import updateExchangeRateDialog from '@/views/cargo/v0/Clearing/components/financeManage/updateExchangeRateDialog'

// components
import tabLessThanCarload from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarload'
import tabGatheringTrailer from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailer'
import financeBtnGroup from './financeBtnGroup'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import basicTab from './basicTab'
import bookingTab from './bookingTab'
import chargeTab from './chargeTab'
import fileHistoryTab from './fileHistoryTab'
import domesticBillTab from './domesticBillTab'
import foreignBillTab from './foreignBillTab'
import agentBusinessTab from './agentBusinessTab'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import tabVesselEqUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEqUICustom'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import ColumnUtils from '@/utils/ColumnUtils'
import { sleep, ensureExecuteSuccess } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import { calculateProfit } from '@/api/seaExport/seaExportJob'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import TabOrderCar from '@/views/cargo/v0/Integrated/components/booking/tabs/tabOrderCar'
import { cache, cacheName } from '@/utils/cacheManager'
import { LOG_FINANCIAL_REVIEW } from '@/class/cargo/model/parameters/SystemConstants'
import tabAirVesselEq from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEq'
import tabAirVesselEqUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEqUICustom'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getUserInfo } from '@/utils/auth'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'FinanceDetail',
  components: {
    tabAirVesselEq,
    tabAirVesselEqUICustom,
    TabOrderCar,
    CargoButtonGroupSlider,
    financeBtnGroup,
    cargoAdvanceSelect,
    tabVesselEq,
    tabVesselEqUICustom,
    tabCharges,
    tabInternalBill,
    tabOverseaBill,
    tabAdvanceCharge,
    tabFileHistory,
    tabSopState,
    agentBusiness: agentBusinessTab,
    basic: basicTab,
    booking: bookingTab,
    charge: chargeTab,
    fileHistory: fileHistoryTab,
    domesticBill: domesticBillTab,
    foreignBill: foreignBillTab,
    cargoTemplateSelectorDialog,
    cargoLeftRightResize,
    updateExchangeRateDialog, tabLessThanCarload, tabGatheringTrailer
  },
  props: {
    viewSource: { type: String, required: true }
  },
  data() {
    const currentUserInfo = getUserInfo()
    const leftGridColumnType = window.localStorage.getItem(`FI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`) || 'jobNo'
    return {
      UICustomConstants,
      leftGridColumnType,
      job: {},
      showContentArea: false,
      loading: false,
      isCommittedAllowAddCost: false,
      financeDetailHp: new FinanceDetailHp(this),
      seContext: new BookingWorkspaceContext(),
      jobUuid: '',
      bookingAction: '',
      activeTabName: 'basic',
      lob: '',
      adjust: true, // 代收垫付页签专用 控制提交/取消提交按钮是否显示
      action: 'look', // 财务审核默认查看状态
      masterFlag: false,
      tabsRenderedSet: new Set(), // 已经渲染操作过的tabs
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        likeName: '' // 模糊查询名称
      },
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      rowData: [],
      jobState: '', // 业务状态
      jobChangeState: '', // 改单状态
      customerChineseName: '', // 客户中文名
      customerEnglishName: '', // 客户英文名
      updateExchangeRateDialog: {
        visible: false,
        jobKeyList: []
      },
      commonInfo: {
        jobTitle: ''
      },
      pushExternalInterfaceStatus: '',
      privilege: {
        charge: {
          chargeReceivable: this.$checkPermission(['tab_Charge_chargeReceivable']),
          chargePayable: this.$checkPermission(['tab_Charge_chargePayable'])
        }
      },
      seChargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false }, // 海出-费用页签设置
      aeChargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false } // 空出-费用页签设置
    }
  },
  computed: {
    showTabSopState() {
      // return (['SI', 'AE', 'AI'].includes(this.lob) && !this.masterFlag) || ['RE', 'RI', 'SE'].includes(this.lob)
      return ['SE', 'SI', 'AE', 'AI', 'RE', 'RI', 'IE'].includes(this.lob)
    },
    isLclMaster() {
      return !!this.job.lclMasterUuid
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.job.cooperateStatus || -1
      if (this.job.cooperate && this.job.cooperate.cooperateStatus) {
        cooperateStatus = this.job.cooperate.cooperateStatus
      }
      return cooperateStatus
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.job.cooperate && this.job.cooperate.uuid) {
        return true
      }
      return false
    },
    location() {
      if (!this.job.fba) {
        return LOG_FINANCIAL_REVIEW.code
      }
      return ''
    },
    jobAndChargeSubmitterAndAuditorCanNotSame() { // 业务和者费用的提交人与审核人不可以相同
      return cache.config ? Number(cache.config.get('JobAndChargeSubmitterAndAuditorCanNotSame')) === 1 : false
    },
    jingyuWarehouse() {
      return cache.config ? Number(cache.config.get('JingyuWarehouse')) === 1 : false
    },
    chargePageSet() {
      switch (this.lob) {
        case 'SE':
          return this.seChargePageSet
        case 'AE':
          return this.aeChargePageSet
        default:
          return { hideTabCharge: false, arAloneShow: false, apAloneShow: false }
      }
    }
  },
  watch: {
    leftGridColumnType(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.gridOptions.api.setAutoGroupColumnDef({
        headerName: newVal === 'jobNo' ? this.$t('SeaExport.BusinessNo') : newVal,
        colId: newVal,
        field: newVal,
        width: 220,
        tooltip: (params) => {
          return newVal === 'jobNo' ? params.data.jobNo : newVal === 'MBL' ? params.data.mbl : params.data.hblNb3
        }
      })
    },
    '$store.getters.currentOfficeId': {
      handler() {
        if (this.$store.state.uiCustom.enable) {
          this.loadPageSet()
        }
      }
    }
  },
  /* async beforeMount() {
    await this.financeDetailHp.beforeMount()
  }, */
  async created() {
    this.financeDetailHp.created()
    this.seContext.prepareData()
    await cache.load(cacheName.CONFIG)
  },
  beforeMount() {
    this.loadPageSet()
  },
  methods: {
    loadPageSet() {
      this.seChargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE)
      this.aeChargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE)
    },
    // 初始化右上角业务等相关状态
    initRightState() {
      this.jobState = ColumnUtils.getJobState(this.job)
      this.initInfo()
      this.jobChangeState = this.financeDetailHp.isCommittedAllowAddCost ? ColumnUtils.getJobChangeState2(this.job) : ''
      console.log(this.job)
      if (!this.job.masterFlag) {
        Company.getCompanyById(this.job.customerId).then(company => {
          this.customerChineseName = company.chineseName
          this.customerEnglishName = company.englishName
        })
      } else {
        this.customerChineseName = ''
        this.customerEnglishName = ''
      }
    },
    handleTabClick() {
      if (!this.tabsRenderedSet.has(this.activeTabName)) {
        this.$nextTick(async() => {
          const loading = getLoading4Cxt(this)
          try {
            this.tabsRenderedSet.add(this.activeTabName)
            await this.$refs[this.activeTabName].onShow(this.job, true)
          } finally {
            loading && loading.close()
          }
        })
      }
    },
    handleCellFocused(e) {
      console.log(e)
      if (!e.column) return
      this.gridApi.clearFocusedCell()
      const { rowsToDisplay } = e.api.getModel()
      const curNode = rowsToDisplay[e.rowIndex]
      curNode.setSelected(true)
      this.gridApi.ensureIndexVisible(curNode.rowIndex)
      this.showDetail(curNode.data)
    },
    async showDetail(oneRowData, treeData) {
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.toRenderTreeGrid(treeData, oneRowData.uuid)
      })
      await this.financeDetailHp.initCache()
      this.lob = oneRowData.lob
      this.masterFlag = oneRowData.masterFlag
      this.jobUuid = oneRowData.uuid
      this.loading = getLoading4Cxt(this)
      this.tabsRenderedSet.clear()
      this.pushExternalInterfaceStatus = ''
      await this.financeDetailHp.getAndSetJobDetail().then(async res => {
        if (oneRowData.cooperatebranch) this.job.cooperatebranch = oneRowData.cooperatebranch // 协作分公司
        this.job.pushExternalInterfaceStatus = oneRowData.pushExternalInterfaceStatus // 推送外部接口状态
        if (this.job.pushExternalInterfaceStatus) {
          this.pushExternalInterfaceStatus = ColumnUtils.zyInterfacePushStatusLabelFunc(this.job.pushExternalInterfaceStatus)
        }
        this.showContentArea = true
        // 因除海出外，其他业务无订舱页签，所以切换业务时，需做控制
        if ((this.activeTabName === 'tabVesselEq' && this.lob !== 'SE') || (this.activeTabName === 'tabSopState' && !this.showTabSopState)) {
          this.activeTabName = 'basic'
        }
        this.initRightState()
        await this.handleTabClick()
      }).catch(() => {
        this.$message.warning(this.$t('Clearing.FailedToGetDetails'))
      }).finally(() => {
        this.loading.close()
      })
    },
    toRenderTreeGrid(treeData, locationUuid) {
      this.gridOptions.api.deselectAll()
      this.gridApi.clearFocusedCell()
      // 更新左侧树
      if (treeData && treeData.length) {
        this.rowData = [...treeData]
      }
      this.$nextTick(() => {
        this.gridOptions.api.forEachNode(node => {
          if (node.data.uuid === locationUuid) {
            node.setSelected(true)
            this.gridApi.ensureIndexVisible(node.rowIndex)
          }
        })
      })
    },
    toBackList() {
      this.$emit('backList', this.viewSource)
    },
    async doPrintPROFIT(event) {
      if (event.action === 'print') {
        if (this.job && this.job.uuid) {
          // MessageDialog.confirm(this.$t('Clearing.AfterForFinancialReviewContinue'), this.$t('Clearing.Warning'), null, onConfirmedPrintProfit);
          await this.$confirm(this.$t('Clearing.AfterForFinancialReviewContinue'), this.$t('Clearing.Warning'), { type: 'warning' })
          this.onConfirmedPrintProfit(event)
        }
      } else {
        calculateProfit(this.job.uuid, -1, true, this.financeDetailHp.allSubmitFcl, false, this.$store.getters.currentOfficeId, '', this.location).then(res => {
          //   FlexGlobals.topLevelApplication.status = "";
          PrintTemplateManager.print(event.template, event.documentType, event.format, event.parameter, false)
        })
        // _job.calculateProfit2(-1, true, allSubmitFcl, false,
        //   function(e:ResultEvent) {
        //   FlexGlobals.topLevelApplication.status = "";
        //
        //     print(template, documentType, format, parameters, inline = true)
        //   PrintTemplateManager.getInstance().print(printEvent.template, printEvent.format, printEvent.parameter,false);
        // }
        // ,failureHandler);
      }
      this.templateSelectorDialog.visible = false
    },
    onConfirmedPrintProfit(event) {
      calculateProfit(this.job.uuid, -1, true, this.financeDetailHp.allSubmitFcl, false, this.$store.getters.currentOfficeId, '', this.location).then(res => {
        // FlexGlobals.topLevelApplication.status = "已保存。";
        if (StimulSoftUtil.isOpenStiReport(event.template)) {
          StimulSoftUtil.stiReportPreview(event.template, this.job, event.parameter)
        } else {
          PrintTemplateManager.print(event.template, event.documentType, event.format, event.parameter, true)
        }
      }).catch(e => {
        this.$message.warning('请输入箱封号后，打印利润分析表。')
      })
      // _job.calculateProfit2(-1, true, allSubmitFcl, false, function(e:ResultEvent):void {
      //   FlexGlobals.topLevelApplication.status = "已保存。";
      //   if (StimulSoftUtil.getInstance().isOpenStiReport(printEvent.template)) {
      //     StimulSoftUtil.getInstance().stiReportPreview(printEvent.template, _job, printEvent.parameter);
      //   } else {
      //     PrintTemplateManager.getInstance().print(printEvent.template, printEvent.format, printEvent.parameter,true);
      //   }
      // },profitFailureHandler);
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      // this.$logger.log('nodes', nodes)
      // this.$logger.log('this.rowData', this.rowData)
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        if (item.data.jobUuid === row.uuid || !item.data.uuid) {
          item.setSelected(true)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    zyInterfacePushStatusLabelFunc(value) {
      return ColumnUtils.zyInterfacePushStatusLabelFunc(value)
    },
    // 加载完job走这里
    initInfo() {
      this.showJobTitle()
    },
    async showJobTitle() {
      const job = this.job
      this.commonInfo.jobTitle = ''
      if (job.customerId) {
        const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
        const cmp = companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          this.commonInfo.jobTitle = '<span style="margin-right:10px">' + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .finance-detail{

    .app-dropdown-menu {
      width: 50px;
    }
    .app-btn-cascader {
      border: none !important;
      border-radius: 0px !important;
    }
    .app-btn-cascader-pop {
      width: 100px;
      background: red;
    }
  }

</style>
